import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { CondicionesVamServices } from "./condiciones.service";
import { CondicionesVamComponent } from "./condiciones.component";


@NgModule({
    declarations: [CondicionesVamComponent],
    imports: [BrowserModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule, DataTableModule],
    exports: [CondicionesVamComponent],
    providers: [CondicionesVamServices]
})

export class CondicionesVamModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/condiciones/condiciones.module.ts